var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',_vm._g({class:[
    'nav-item',
    { active: _vm.active, 'nav-item--active-bar': _vm.active && _vm.activeBar }
  ],attrs:{"title":_vm.title,"href":_vm.path},on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.onClick($event)}}},_vm.$listeners),[_vm._v("\n  "+_vm._s(_vm.title)+"\n  "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }